import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Button from '../../../UI/Button/Button';
import classes from './Buttons.module.css';

const Buttons = ({ nextSection }) => {
  const history = useHistory();
  const goHomeHandler = () => {
    history.push('/#home');
  };
  if (nextSection) {
    const { name, link, defaultSubsection, color } = nextSection;
    return (
      <div className={classes.buttonsContainer}>
        <Button backgroundColor="white" color="black" onClick={goHomeHandler}>
          Return Home
        </Button>
        <Button
          backgroundColor={color}
          color="white"
          onClick={() => history.push(`${link}/${defaultSubsection || ''}`)}
        >
          Up Next: {name}
        </Button>
      </div>
    );
  }
  return (
    <div className={classes.buttonContainer}>
      <Button backgroundColor="white" color="black" onClick={goHomeHandler}>
        Back to Home
      </Button>
    </div>
  );
};

Buttons.propTypes = {
  nextSection: PropTypes.shape({
    name: PropTypes.string,
    link: PropTypes.string,
    color: PropTypes.string,
    defaultSubsection: PropTypes.string,
  }),
};

Buttons.defaultProps = {
  nextSection: undefined,
};

export default Buttons;
